export const isAllowedSuperOpsRoute = (): boolean => {
	const pathname = window.location.pathname;

	const allowedPaths = ["/opportunities", "/documents"];

	return allowedPaths.some(path => {
		return pathname === path || pathname.startsWith(path + "/");
	});
};
